import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { topMenuData } from './topMenuData';
import { topMenuData as topMenuData_IE } from './topMenuData_ie';
import { footerData } from './footerData';
import { footerData as footerData_IE } from './footerData_ie';

import { Menu } from './menu';

/**
 * This component builds the main site navigation and additionally the footer site navigation. It is currently driven
 * by data contained in both topMenuData.js and footerData.js, with the idea that this will eventually come from
 * the CMS via GraphQL. The data describes objects with a 'type' property which refers to one of the sub components in
 * this folder and other properties specific to the component. Most have the ability to set a className and almost all
 * have a 'children' property which is an optional array of more menu items.
 *
 * @function
 * @param       {string} style    either 'main' or 'footer' depending on the position of this component.
 * @param       {function} setShade state Function called with parameters to show or hide the shade component.
 * @param       {string} market UK or IE depending on which menu we are rendering
 * @constructor
 */
function SiteNav({ style, setShade, market }) {
    const [openMenu, setOpenMenu] = useState('');
    const [openMobileMenu, setOpenMobileMenu] = useState(null);

    // Show or hide the shade depending if any menu sub navigations items are shown.
    useEffect(() => {
        if (
            typeof setShade !== 'function' ||
            typeof openMenu !== 'string' ||
            openMobileMenu
        ) {
            return;
        }

        if (openMenu && openMenu !== '') {
            setShade({
                opener: 'SiteNav',
                shade: true,
                menu: true,
                onClick: () => setOpenMenu && setOpenMenu('')
            });
        } else if (openMenu === '') {
            setShade({ closer: 'SiteNav', shade: false });
        }
    }, [openMenu]);

    const track = style === 'main' ? 'SiteNav' : 'Footer';

    const menuProps = {
        openMenu,
        setOpenMenu,
        openMobileMenu,
        setOpenMobileMenu,
        track
    };

    const mainMenuProps = {
        ...menuProps,
        ...(market === 'UK' ? topMenuData : topMenuData_IE)
    };

    const footerMenuProps = {
        ...menuProps,
        ...(market === 'UK' ? footerData : footerData_IE)
    };

    return (
        <>
            {style && style === 'main' ? (
                <>
                    <header>
                        <Menu {...mainMenuProps} />
                    </header>
                </>
            ) : (
                <Menu {...footerMenuProps} />
            )}
        </>
    );
}

export { SiteNav };

SiteNav.propTypes = {
    market: PropTypes.string,
    style: PropTypes.oneOf(['main', 'footer']),
    shade: PropTypes.object,
    setShade: PropTypes.func
};
